import IAppLogger from '@app/lib/IAppLogger';
import DiagnosticsModule from '@modules/DiagnosticsModule';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import { serviceState } from '@modules/ServiceModule/workspace/lib/state';
import { isRtcsOutageActive } from '@modules/ServiceModule/workspace/lib/rtcsConnectionStatus';
import { phoneState } from '../state';
import {
  ConnectionStatusType,
  ConnectionStatusUpdatePayload,
  WebphoneConnectionStatus,
} from '../types';
import { connectionStatusStrings } from '../constants/connectionStatusStrings';
import { clearRecoveryState } from '../lib/clearRecoveryState';

const handleConnectionStatusUpdate = (
  payload: ConnectionStatusUpdatePayload,
  logger: IAppLogger,
) => {
  const { status, timestamp, details } = payload;

  logger.debug('[WebPhone] Connection status update', {
    status,
    timestamp,
    details,
  });

  if (
    status === ConnectionStatusType.RecoveryStarted &&
    phoneState.connectionStatus === WebphoneConnectionStatus.Disconnected &&
    !phoneState.isRecovering
  ) {
    phoneState.isRecovering = true;

    const suppressRecoveryToast = isRtcsOutageActive({
      flagEnabled: FeatureFlagModule.isEnabled(
        FeatureFlagKeys.featureRtcsConnectionStatusAnnouncement,
      ),
      loading: serviceState.loading,
      error: serviceState.error,
      serviceConnected: serviceState.serviceConnected,
    });
    if (!suppressRecoveryToast) {
      DiagnosticsModule.reportUserError(
        connectionStatusStrings.recoveryStarted,
        {
          priority: 'passive',
          source: 'softphone',
        },
      );
    }
  } else if (status === ConnectionStatusType.RecoverySuccess) {
    clearRecoveryState();
  }
};

export default handleConnectionStatusUpdate;
